import React from 'react';

import { Dialog } from '@buildoutinc/blueprint-react/ui/Dialog';
import Button from 'shared/button';

interface Props {
  show?: boolean;
  voucherCount?: number;
  onConfirm: () => void;
  onHide: () => void;
}

export default function WarningModal({ onConfirm, onHide, show, voucherCount = 0 }: Props) {
  const handleConfirm = () => {
    onConfirm();
    onHide();
  };

  const handleOpenChange = (open: boolean) => {
    if (!open) onHide();
  };

  const plural = voucherCount > 1;

  return (
    <Dialog open={show} onOpenChange={handleOpenChange}>
      <Dialog.Content>
        <Dialog.Header>
          <Dialog.Title>Reset Approval Workflow</Dialog.Title>
        </Dialog.Header>
        <Dialog.Body>
          <p>
            There {plural ? 'are' : 'is'} currently {voucherCount} voucher{plural ? 's' : ''} pending approval
            that use{plural ? '' : 's'} the current workflow. {plural ? 'These vouchers' : 'This voucher'} will be
            reset to the first step of the workflow, with no approvals.
          </p>
          <p>Are you sure you want to continue?</p>
        </Dialog.Body>
        <Dialog.Footer>
          <Dialog.Cancel>Cancel</Dialog.Cancel>
          <Button.Primary onClick={handleConfirm}>Yes, Reset Workflow</Button.Primary>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog>
  );
}
